import { createStore } from "vuex";

import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default createStore({
  plugins: [vuexLocal.plugin],
  state: {
    token: localStorage.getItem('auth_token') || "",
    userId: localStorage.getItem('user_id') || "",
    userEmail: localStorage.getItem('user_email') || "",
    user: JSON.parse(localStorage.getItem('user_data')) || null,
    articles: [],
    news: [],
    slides: [],
    searchQuery: "",
    toast: {
      show: false,
      message: "",
      type: "success" // success, error, info
    }
  },
  getters: {
    isLoggedIn: state => !!state.token && !!state.user
  },
  mutations: {
    showToast(state, { message, type = "success" }) {
      state.toast = { show: true, message, type };
    },
    hideToast(state) {
      state.toast.show = false;
    },
    setToken(state, payload) {
      state.token = payload;
      if (payload) localStorage.setItem('auth_token', payload);
      else localStorage.removeItem('auth_token');
    },
    setUserId(state, payload) {
      state.userId = payload;
      if (payload) localStorage.setItem('user_id', payload);
      else localStorage.removeItem('user_id');
    },
    setUserEmail(state, payload) {
      state.userEmail = payload;
      if (payload) localStorage.setItem('user_email', payload);
      else localStorage.removeItem('user_email');
    },
    setUserData(state, payload) {
      state.user = payload;
      if (payload) localStorage.setItem('user_data', JSON.stringify(payload));
      else localStorage.removeItem('user_data');
    },
    logout(state) {
      state.token = "";
      state.userId = "";
      state.userEmail = "";
      state.user = null;

      // Complete cleanup of storage
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_data');

      // Security measure: Clear all remaining items to be absolutely sure
      localStorage.clear();
      console.log("Session absolute cleanup complete.");
    },
    setArticles(state, payload) {
      state.articles = payload;
    },
    setNews(state, payload) {
      state.news = payload;
    },
    setSlides(state, payload) {
      state.slides = payload;
    },
    setSearchQuery(state, payload) {
      state.searchQuery = payload;
    },
  },
  actions: {},
  modules: {},
});
